import React from "react";
import Modal from "../Modal";
import "./styles.scss";

const FILTERS = [
  {
    type: "Studio",
    units: [
      {
        name: "Unit 20C",
        path: "https://my.matterport.com/show/?m=CgqnYX8Gwmz",
      },
    ],
  },
  {
    type: "Two Bedroom",
    units: [
      {
        name: "Unit 26A",
        path: "https://my.matterport.com/show/?m=mwX5ziVZVxu",
      }
    ],
  },
];

class ScheduleTourModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      iframeUrl: "https://my.matterport.com/show/?m=CgqnYX8Gwmz",
      activeFilter: "Studio",
    };
  }

  updateTour = (url) => {
    // ga('garp.send', "event", "3D", "Click", "Matterport", "0");
    this.setState({ iframeUrl: url });
  };

  setActiveFilter = (filter) => {
    // ga('garp.send', "event", "3D", "Click", "Matterport", "0");
    this.setState({ activeFilter: filter });
  };

  render() {
    const { activeFilter, iframeUrl } = this.state;
    return (
      <Modal
        id="tourModal"
        className="tour-modal"
        persistent={false}
        {...this.props}
      >
        <div className="tour-modal-inner">
          <div className="tour-modal-filters">
            {FILTERS.map((item, i) => {
              return (
                <div
                  className={`tour-modal-filters-section ${
                    activeFilter === item.type ? "active" : ""
                  }`}
                  key={i}
                >
                  <h4
                    className="tour-modal-filters-section-title"
                    onClick={() => this.setActiveFilter(item.type)}
                  >
                    {item.type}
                  </h4>
                  <ul className="tour-modal-filters-section-list">
                    {item.units.map((item, i) => {
                      return (
                        <li
                          className={`tour-modal-filters-section-list-item ${
                            iframeUrl === item.path ? "active" : ""
                          }`}
                          key={i}
                          onClick={() => this.updateTour(item.path)}
                        >
                          {item.name}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              );
            })}
          </div>
          <iframe
            className="tour-modal-iframe"
            src={iframeUrl}
            frameBorder="0"
            allowFullScreen
            allow="vr"
          ></iframe>
        </div>
      </Modal>
    );
  }
}

export default ScheduleTourModal;



// WEBPACK FOOTER //
// ./client/components/VirtualTourModal/index.js